export interface Gericht {
  id: number;
  name: string;
  kategorie: string;
  subkategorie?: string | null;
  saison: string;
  beschreibung?: string | null;
  datum: string | null;
}

export const KATEGORIEN = ['Vorspeise', 'Suppe', 'Hauptgang', 'Dessert'];
export const SAISONEN = ['Frühling', 'Sommer', 'Herbst', 'Winter'];
export const SUBKATEGORIEN = ['Fleisch', 'Fisch', 'Alternative', 'Vegetarisch'];

export const KATEGORIE_FARBEN: Record<string, string> = {
  Vorspeise: '#2e7d32', Suppe: '#ef6c00', Hauptgang: '#c62828', Beilage: '#6a1b9a', Dessert: '#ad1457',
};
export const SUBKATEGORIE_FARBEN: Record<string, string> = {
  Fleisch: '#6d4c41', Fisch: '#0277bd', Alternative: '#6a1b9a', Vegetarisch: '#388e3c',
};
// Bewusst andere Töne als die Kategorien, damit "Herbst" nicht wie "Hauptgang" aussieht
export const SAISON_FARBEN: Record<string, string> = {
  Frühling: '#7cb342', Sommer: '#f9a825', Herbst: '#a1662f', Winter: '#5c8fbf',
};

export const MONATE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

export function datumFormat(datum: string | null | undefined) {
  return datum ? new Date(datum).toLocaleDateString('de-DE') : '';
}
